import { createContext, useContext } from 'react';
import type { Page } from '../../constants/PageConfig';

export const PageConfigContext = createContext<Page[]>([]);

export const usePageConfigContext = (): Page[] => {
	return useContext(PageConfigContext);
};
